import React from "react";
import CustomBigText from "./customBigText";
const CustomTitle = ({ title }) => {
  return (
    <div className="flex items-center ">
      <div className="flex-1 h-1 bg-black"></div>
      <CustomBigText title={title} className="mx-4" />
      <div className="flex-1 h-1 bg-black"></div>
    </div>
  );
};

export default CustomTitle;
